import React, { useState, useEffect } from "react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../ui/select";
import { BaseFormFields, useBaseForm } from "./BaseFormFields";
import * as api from "../../lib/api";

export function NewEquipmentForm({ onSubmit, initialData, readOnly, submitting, onTitleChange, allowedPriorities, ticketType, onTypeChange }) {
    const baseForm = useBaseForm("medium");
    const [equipment, setEquipment] = useState([]);
    const [equipmentType, setEquipmentType] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [justification, setJustification] = useState("");
    const [deliveryDate, setDeliveryDate] = useState("");

    useEffect(() => {
        loadEquipment();
    }, []);

    const loadEquipment = async () => {
        try {
            const data = await api.getEquipmentCatalog();
            setEquipment(data);
        } catch (error) {
            console.error("Failed to load equipment:", error);
        }
    };

    const selectedEquipment = equipment.find((e) => e.id === equipmentType);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            title: baseForm.title || `Demande de matériel - ${selectedEquipment?.name || ""}`,
            description: baseForm.description,
            priority: baseForm.priority,
            dynamic_fields: {
                equipment_type: selectedEquipment?.equipment_type || equipmentType,
                quantity: parseInt(quantity),
                business_justification: justification,
                desired_delivery_date: deliveryDate,
            },
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <BaseFormFields
                ticketType={ticketType}
                onTypeChange={onTypeChange}
                {...baseForm}
                onTitleChange={onTitleChange}
                    allowedPriorities={allowedPriorities}
                titlePlaceholder="Ex: Demande d'un second écran"
                descriptionPlaceholder="Contexte de la demande..."
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="form-group">
                        <Label className="form-label">Type de matériel</Label>
                        <Select value={equipmentType} onValueChange={setEquipmentType}>
                            <SelectTrigger data-testid="equipment-type">
                                <SelectValue placeholder="Sélectionner" />
                            </SelectTrigger>
                            <SelectContent>
                                {equipment.map((eq) => (
                                    <SelectItem key={eq.id} value={eq.id}>
                                        {eq.name}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>

                    <div className="form-group">
                        <Label className="form-label">Quantité</Label>
                        <Input
                            type="number"
                            min={1}
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            data-testid="quantity"
                        />
                    </div>
                </div>

                <div className="form-group">
                    <Label className="form-label">Date de livraison souhaitée</Label>
                    <Input
                        type="date"
                        value={deliveryDate}
                        onChange={(e) => setDeliveryDate(e.target.value)}
                        data-testid="delivery-date"
                    />
                </div>

                <div className="form-group">
                    <Label className="form-label">Justification métier</Label>
                    <Textarea
                        value={justification}
                        onChange={(e) => setJustification(e.target.value)}
                        placeholder="Pourquoi avez-vous besoin de ce matériel ?"
                        data-testid="justification"
                    />
                </div>
            </BaseFormFields>

            <div className="mt-6 flex justify-end">
                <Button type="submit" disabled={!baseForm.title || submitting} data-testid="submit-ticket">
                    {submitting ? "Création..." : "Soumettre le ticket"}
                </Button>
            </div>
        </form>
    );
}
